/**
 * 是否有子集
 * @param {Object} option 配置
 * @returns {Array} 格式化后数据
 */
export const hasChildren = data => {
  let res = false
  if (Array.isArray(data)) {
    data.forEach(item => {
      if (Array.isArray(item.children)) {
        if (item.children.length > 0) {
          res = true
        }
      }
    })
  }
  return res
}

export default true
